import { DesignData } from 'editor/src/store/design/types';

import { SharedTextFieldMember } from './sharedTextFields';

export const MAX_FIELD_KEY_LENGTH = 64;

const TRANSLITERATIONS: Record<string, string> = {
  ø: 'o',
  æ: 'ae',
  œ: 'oe',
  ß: 'ss',
  ł: 'l',
  đ: 'd',
  ð: 'd',
  þ: 'th',
  ı: 'i',
};

/**
 * The key as the author typed it, made safe to put in a host's code: lowercase,
 * spaces and dashes as `_`, accents dropped, letters without one spelled out
 * (ø → o, æ → ae), anything else removed. Not trimmed:
 * it runs on every keystroke, and "deceased " has to survive until "name" follows. Undefined when nothing is left,
 * so clearing the input removes the key.
 */
export function normalizeFieldKey(input: string): string | undefined {
  const key = input
    .toLowerCase()
    // å → a, é → e: accents are dropped rather than the whole letter
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    // Letters NFD leaves whole; stripping them would turn "avdøde" into "avdde"
    .replace(/[øæœßłđðþı]/g, (letter) => TRANSLITERATIONS[letter])
    .replace(/[\s-]+/g, '_')
    .replace(/[^a-z0-9_]/g, '')
    .slice(0, MAX_FIELD_KEY_LENGTH);
  return key || undefined;
}

/** Every text carrying `fieldKey`, in design order (spread, then page, then element). */
export function getFieldKeyMembers(designData: DesignData | undefined, fieldKey: string): SharedTextFieldMember[] {
  const members: SharedTextFieldMember[] = [];
  designData?.spreads.forEach((spread, spreadIndex) => {
    spread.pages.forEach((page, pageIndex) => {
      page.groups.media?.forEach((element, elementIndex) => {
        if (element.type === 'text' && element.extra.fieldKey === fieldKey) {
          members.push({ element, address: { spreadIndex, pageIndex, elementIndex } });
        }
      });
    });
  });
  return members;
}
